<script setup>
// Divisor entre colunas da linha selecionada: arrastar muda as larguras (5 em 5%).
import { dragWidths } from './geometry';

const props = defineProps({
  widths: { type: Array, required: true },
  index: { type: Number, required: true },
  contentPx: { type: Number, required: true },
});
const emit = defineEmits(['change']);

const start = event => {
  const startX = event.clientX;
  const initial = [...props.widths];
  let last = initial.join(',');
  const onMove = e => {
    const next = dragWidths(
      initial,
      props.index,
      e.clientX - startX,
      props.contentPx
    );
    if (next.join(',') === last) return;
    last = next.join(',');
    emit('change', next);
  };
  const onUp = () => {
    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerup', onUp);
  };
  window.addEventListener('pointermove', onMove);
  window.addEventListener('pointerup', onUp);
};
</script>

<template>
  <div
    class="relative z-10 -mx-1 w-2 shrink-0 cursor-col-resize"
    @pointerdown.stop.prevent="start"
    @click.stop
  >
    <div
      class="absolute inset-y-0 left-1/2 w-0.5 -translate-x-1/2 bg-n-brand"
    />
    <span
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-n-brand p-0.5 text-white"
    >
      <span class="i-lucide-move-horizontal block size-3" />
    </span>
  </div>
</template>
